import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getTerminals } from "components/Apis/terminal";
import { apiUrl } from "config"

export const fetchTerminals = createAsyncThunk(
    'filter/fetchTerminals',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await getTerminals(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const terminalSlice = createSlice({
    name: 'terminals',
    initialState: {
        currentTerminal: null,
        terminals: [],         
        loading: false,      
        error: null,
    },
    reducers: {
        setCurrentTerminal: (state, action) => {
            state.currentTerminal = action.payload;
        },
        resetTerminals: (state) => {
            state.terminals = [];
            state.currentTerminal = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTerminals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTerminals.fulfilled, (state, action) => {
                state.loading = false;
                state.terminals = action.payload;
            })
            .addCase(fetchTerminals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
    },
});

export const { setCurrentTerminal, resetTerminals } = terminalSlice.actions;
export default terminalSlice.reducer;